import { render, staticRenderFns } from "./PrizeList.vue?vue&type=template&id=3556eed0&scoped=true"
import script from "./PrizeList.vue?vue&type=script&lang=js"
export * from "./PrizeList.vue?vue&type=script&lang=js"
import style0 from "./PrizeList.vue?vue&type=style&index=0&id=3556eed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556eed0",
  null
  
)

export default component.exports